import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
} from "../actions/types";
if (!localStorage.length) {
  localStorage.setItem("getlocalStorage", "foobar");
  localStorage.removeItem("getlocalStorage", "foobar");
}
let user = JSON.parse(localStorage.getItem("token"));
let localstorage = localStorage.getItem("localStorage");

if (localstorage && !user) {
  var data = JSON.parse(localstorage);
  for (var key in data) {
    localStorage.setItem(key, data[key]);
  }
  user = JSON.parse(localStorage.getItem("token"));
}
if (!localstorage) {
  user = null;
}
//end of code
const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export default function auth(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      return state;
  }
}
